import 'react';
import '@backstage/plugin-catalog-react';
import '@backstage/core-components';
import '@material-ui/core';
import './widgets/LanguagesCard/LanguagesCard.esm.js';
import './widgets/PeopleCard/PeopleCard.esm.js';
import './widgets/MergeRequestStats/MergeRequestStats.esm.js';
import '@material-ui/lab/Alert';
import 'react-use';
import { GITLAB_ANNOTATION_PROJECT_ID, GITLAB_ANNOTATION_PROJECT_SLUG } from './gitlabAppData.esm.js';
export { GITLAB_ANNOTATION_CODEOWNERS_PATH, GITLAB_ANNOTATION_INSTANCE, GITLAB_ANNOTATION_README_PATH, gitlabCodeOwnerPath, gitlabInstance, gitlabProjectId, gitlabProjectSlug, gitlabReadmePath } from './gitlabAppData.esm.js';
import '../api/GitlabCIApi.esm.js';
import './utils.esm.js';
import 'dayjs';
import '@backstage/core-plugin-api';
import './widgets/MergeRequestsTable/Icons.esm.js';
import '@material-ui/core/Link';
import './widgets/ReleasesCard/ReleasesCard.esm.js';
import './widgets/ReadmeCard/ReadmeCard.esm.js';
import './widgets/CoverageCard/CoverageCard.esm.js';

const isGitlabAvailable = (entity) => isGitlabProjectIDAnnotationAvailable(entity) || isGitlabSlugAnnotationAvailable(entity);
const isGitlabProjectIDAnnotationAvailable = (entity) => {
  var _a;
  return Boolean((_a = entity.metadata.annotations) == null ? void 0 : _a[GITLAB_ANNOTATION_PROJECT_ID]);
};
const isGitlabSlugAnnotationAvailable = (entity) => {
  var _a;
  return Boolean((_a = entity.metadata.annotations) == null ? void 0 : _a[GITLAB_ANNOTATION_PROJECT_SLUG]);
};

export { GITLAB_ANNOTATION_PROJECT_ID, GITLAB_ANNOTATION_PROJECT_SLUG, isGitlabAvailable, isGitlabProjectIDAnnotationAvailable, isGitlabSlugAnnotationAvailable };
//# sourceMappingURL=index.esm.js.map
